module.exports = "https://health.dajiuxing.com.cn/img/assets/serviceImg/yljh1.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2FserviceImg%2Fyljh1.png
// module id = jArX
// module chunks = 93